import { render, staticRenderFns } from "./outfitimage.vue?vue&type=template&id=cb3f4050&scoped=true"
import script from "./outfitimage.vue?vue&type=script&lang=js"
export * from "./outfitimage.vue?vue&type=script&lang=js"
import style0 from "./outfitimage.vue?vue&type=style&index=0&id=cb3f4050&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3f4050",
  null
  
)

export default component.exports